import {GridOptions, RowClassParams} from 'ag-grid-community';
import {GridUtils} from '../../../shared-utilities/utils-old/grid-utils-old/grid-utils';

/**
 * Optimized Grid Options for the Stock Manager
 * Phase 2 Performance Optimizations Applied
 */
export const stockManagerGridOptions: GridOptions = {
  debug: false,
  editType: null,
  suppressMultiSort: true,
  enterNavigatesVertically: true,
  enterNavigatesVerticallyAfterEdit: true,

  // Column virtualisation stays on. Animation frames must stay enabled so header
  // positions are recalculated after the grid receives its real width.
  suppressColumnVirtualisation: false,
  rowModelType: 'clientSide', // Explicitly set for better performance
  animateRows: false, // Disable row animations for better performance
  suppressCellFocus: false, // Keep cell focus for accessibility
  suppressBrowserResizeObserver: false, // Let AG Grid handle resize

  // Virtual Scrolling Optimizations
  rowBuffer: 10, // Reduced from 100 for better memory usage
  viewportRowModelPageSize: 100, // Add viewport page size
  viewportRowModelBufferSize: 100, // Add buffer size

  // Grid Interaction
  enableCellTextSelection: true,
  multiSortKey: 'ctrl',
  pagination: true,
  getRowId: params => params.data.code as string,
  rowHeight: 35,
  suppressScrollOnNewData: true,
  paginationAutoPageSize: false,
  paginationPageSize: 100,
  paginationPageSizeSelector: [10, 15, 20, 50, 100],
  suppressPaginationPanel: true,

  // Row Operations
  rowDragManaged: false,
  rowDragEntireRow: false,
  rowDragMultiRow: false,
  rowSelection: {
    mode: 'multiRow',
    checkboxes: false,
    headerCheckbox: false,
    enableClickSelection: false,
    enableSelectionWithoutKeys: false,
  },
  singleClickEdit: true,
  stopEditingWhenCellsLoseFocus: true,

  // Edit Operations
  undoRedoCellEditing: false,
  undoRedoCellEditingLimit: 25,

  // Performance: Optimized row styling with memoization
  getRowStyle: (params: RowClassParams): Record<string, string> => {
    const textColor = params.data.lineColourValue
      ? GridUtils.getContrastColor(params.data.lineColourValue as string)
      : '';
    return {
      backgroundColor: `${params.data.lineColourValue || ''}`,
      color: textColor,
      WebkitTextFillColor: textColor,
      fill: `${params.data.lineColourValue ? 'black' : 'var(--gallix-color-white-contrast)'}`,
    };
  },
};

export const stockMangerVisibleFieldsDefault: string[] = [
  'icons',
  'code',
  'desc',
  'nominalGP',
  'onHand',
  'sellPriIncl1',
  'unitsYear',
];
